import { trackPageView } from 'lib/mixpanel';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ID_SEGMENT = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

// O token de /templates/:token é um segredo de acesso e não pode chegar ao Mixpanel.
const TOKEN_PARENT_SEGMENTS = ['templates'];

export function normalizePagePath(pathname: string, publicUrl = process.env.PUBLIC_URL ?? '') {
	const prefix = publicUrl.replace(/\/+$/, '');
	const isUnderPrefix = prefix && (pathname === prefix || pathname.startsWith(`${prefix}/`));
	const appPath = isUnderPrefix ? pathname.slice(prefix.length) : pathname;

	const segments = appPath
		.split('/')
		.filter(Boolean)
		.map((segment, index, all) => {
			if (index > 0 && TOKEN_PARENT_SEGMENTS.includes(all[index - 1])) return ':token';
			return ID_SEGMENT.test(segment) ? ':id' : segment;
		});

	return `/${segments.join('/')}`;
}

export function PageView({ pageName }: { pageName: string }) {
	const lastTracked = useRef<string | null>(null);

	useEffect(() => {
		if (pageName === lastTracked.current) return;
		lastTracked.current = pageName;

		trackPageView(pageName);
	}, [pageName]);

	return null;
}

// A tela principal fica numa rota só e troca de conteúdo por abas: ela mesma registra a aba ativa.
const SELF_TRACKED_PAGES = ['/'];

export function PageViewTracker() {
	const { pathname } = useLocation();
	const pageName = normalizePagePath(pathname);

	if (SELF_TRACKED_PAGES.includes(pageName)) return null;

	// A chave por pathname mantém um evento por rota visitada, mesmo quando duas rotas normalizam igual.
	return <PageView key={pathname} pageName={pageName} />;
}
